<script>
    import {Splide, SplideSlide} from "@splidejs/svelte-splide";
    import {eventBus} from "../core/event-bus-store.js";
    import {mediaUrlStore} from "../core/app-store.js";

    export let gallery = {};
    export let tenantKey = '';

    const options = {
        type: 'loop',
        height: '50vh',
        drag: true,
        lazyLoad: 'nearby',
        preloadPages: 1,
        snap: true,
        interval: 5000,
        autoplay: false,
        // perPage: 2,      // desktop
        // gap: '1.5rem',   // desktop
        mediaQuery: 'max',
        breakpoints: {
            640: {          // mobile
                arrows: false,
                perPage: 1,
                gap: 0,
            }
        },
    };

    options.height = `${gallery?.height || 50}vh`;
    options.autoplay = gallery?.autoplay === true;
    options.interval = gallery?.autoplayInterval || 5000;

    let id = Math.random().toString().split('.')[1];

    const openFullscreen = (media) => {
        eventBus.set([{event: 'openFullscreen', payload: {media}}]);
    }

</script>
<style>
.gallery-container {
    height: 100%;
    width: 100%;
    max-height: 100%;
    min-width: 100%;
    position: relative;
}
.gallery-item {
    height: 100%;
    position: relative;
}
.text-container {
    position: absolute;
    color: #fff;
    top: 0;
    left: 0;
    font-family: inherit;
    box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.25);
    background: rgb(0 0 0 / 45%);
    padding: 1rem 1rem 1rem 1rem;
    width: 100%;
}
.title {
    font-size: 1.1rem;
    font-weight: 500;
}
.text {
    font-size: .9rem;
    font-weight: 200;
    white-space: pre-wrap;
}

.image,
.video,
.video video {
    height: 100%;
    width: 100%;
    object-fit: cover;
}

.gallery-list {
    display: flex;
    flex-wrap: wrap;
    gap: .5rem;
}
.gallery-list li {
    margin: 0;
    padding: 0;
    flex: 1 1;
    flex-basis: 40%;
    border-radius: var(--border-radius-xs);
    overflow: hidden;
}
.gallery-list li video {
    width: 100%;
}

</style>

<div class="gallery-container">

    <!-- SLIDER -->
    {#if (gallery.type === 'slider')}

        <Splide id={id} aria-label="" options={options}>
            {#each gallery.items as media}
                <SplideSlide>
                    <div class="gallery-item" on:click={() => openFullscreen(media)}>

                        {#if (media.type === 'photo')}
                            <img class="image"
                                 src="{$mediaUrlStore}{media.ref || tenantKey}{media.url}"
                                 loading="lazy"
                                 alt="{media?.title}">
                        {/if}

                        {#if (media.type === 'video')}
                            <div class="video">
                                <video controls="true" loading="lazy">
                                    <source src="{$mediaUrlStore}{media.ref || tenantKey}{media.url}" type="video/mp4">
                                    <track kind="captions">
                                </video>
                            </div>
                        {/if}

                        {#if (media.title || media.text) }
                            <div class="text-container">
                                {#if (media.title)}
                                    <div class="title">{ media.title }</div>
                                {/if}
                                {#if (media.text)}
                                    <div class="text">{ media.text }</div>
                                {/if}
                            </div>
                        {/if}
                    </div>

                </SplideSlide>
            {/each}
        </Splide>

    {/if}

    {#if (gallery.type === 'list')}

        <ul class="gallery-list">

            {#each gallery.items as media}
            <li>
                {#if (media.type === 'photo')}
                    <img on:click={() => openFullscreen(media)}
                         class="image"
                         loading="lazy"
                         src="{$mediaUrlStore}{media.ref || tenantKey}{media.url}"
                         alt="{media?.title}">
                {/if}
                {#if (media.type === 'video')}
                    <video controls="true" loading="lazy">
                        <source src="{$mediaUrlStore}{media.ref || tenantKey}{media.url}" type="video/mp4">
                        <track kind="captions">
                    </video>
                {/if}
            </li>
            {/each}

        </ul>
    {/if}
</div>
